export const initializeStoreblocksAssets = (): void => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = window.config.storeblocksAssetsUrl;
  document.head.appendChild(link);
};
